var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScrumlrLp01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 160,
    height: 160,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(824 187)",
    fill: "#242c3d",
    d: "M0 0h160v160H0z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "B",
    d: "M904.016 262.136l62.105 31.727-62.105 31.623-62.17-31.623z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-824 -187)",
    clipPath: "url(#A)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B",
    fill: "#E20360"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#5e00ff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M841.866 293.868l62.143 31.608v15.104l-62.142-33.205z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M966.122 293.856l-62.113 31.632-.007 15.1 62.121-32.872z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M904.016 230.466l62.105 31.727-62.105 31.623-62.17-31.623z",
    fill: "#E20360"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#5e00ff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M841.866 262.198l62.143 31.608v15.104l-62.142-33.205z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M966.122 262.186l-62.113 31.632-.007 15.1 62.121-32.872z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M904.016 199.999l62.105 31.727-62.105 31.623-62.17-31.623z",
    fill: "#E20360"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#5e00ff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M841.866 231.731l62.143 31.608v15.104l-62.142-33.205z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M966.122 231.719l-62.113 31.632-.007 15.1 62.121-32.872z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrumlrLp01);
export default __webpack_public_path__ + "static/media/scrumlr-lp-01.7cc3081901ecdbfa712906a7e7296f5f.svg";
export { ForwardRef as ReactComponent };